import { FieldErrors } from 'react-hook-form';

import { IFormState, IOfferCalculatorSubmitPayload, TAnalytics } from 'shared/offerCalculator/types/calculator';

export enum ECalculatorEventName {
  onSubmit = 'offerCalculatorOnSubmit',
  onError = 'offerCalculatorOnError',
  onSendAnalytics = 'offerCalculatorOnSendAnalytic',
  /** Входящее событие: хост сбрасывает форму к начальным значениям */
  onReset = 'offerCalculatorOnReset',
}

export type TEventPayload<T = undefined> = T extends undefined
  ? { description: string }
  : { description: string; data: T };

export interface ICalculatorWidgetEventMap {
  [ECalculatorEventName.onSubmit]: TEventPayload<IOfferCalculatorSubmitPayload>;
  [ECalculatorEventName.onError]: TEventPayload<FieldErrors<IFormState>>;
  [ECalculatorEventName.onSendAnalytics]: TEventPayload<TAnalytics>;
  [ECalculatorEventName.onReset]: TEventPayload;
}
